<template>
  <v-card dark>
    <v-card-title v-if="props.title">
      {{ props.title }}
    </v-card-title>
    <v-card-text>
      <v-text-field
        class="ma-0 mb-5"
        :label="label"
        auto-grow
        v-model.trim="item"
        type="text"
        required
        :hide-details="true"
        :color="color"
        :prefix="prefix"
      ></v-text-field>
    </v-card-text>
  </v-card>
</template>

<script>
// @ is an alias to /src
export default {
  name: "TextField",
  props: {
    label: String,
    title: String,
    color: String,
    value: String,
    props: {
      type: Object,
      default: null,
    },
    prefix: {
      type: String,
      default: "",
    },
  },
  data() {
    return {
      item: this.value,
    };
  },
  watch: {
    item: {
      deep: true,
      handler(val) {
        this.$emit("input", val);
      },
    },
    value(val) {
      this.item = val;
    },
  },
};
</script>
